export const site = {
    name: "Revautoz",
    descriptor: "Revautoz — by Apex Automotive",
    tagline: "PRECISION. PROTECTION. PERFORMANCE.",
    phone: "+919225334711",
    phoneDisplay: "+91 92253 34711",
    phoneSecondary: "+918830120259",
    phoneSecondaryDisplay: "+91 88301 20259",
    whatsappNumber: "919225334711",
    whatsappLink: "https://wa.me/message/JBYSAZWZIDYDO1",
    instagram: "https://instagram.com/revautoz",
    instagramHandle: "@revautoz",
    googleProfile: "https://share.google/SMv3c9GgcwfJpdYTW",
    website: "https://www.revautoz.com",
    address: {
        lines: [
            "Revautoz — by Apex Automotive",
            "Apex Automotive, Mushirwada",
            "Near Picnic Garden and Binani",
            "Colvale, Mapusa, Bardez, Goa",
        ],
        mapsQuery: "Apex Automotive, Mushirwada, Colvale, Mapusa, Bardez, Goa",
    },
    hours: [
        { days: "Monday — Saturday", time: "9:30 AM — 6:30 PM" },
        { days: "Sunday", time: "Closed" },
    ],
};

export const offer = {
    label: "Limited Period Offer",
    title: "Up to 20% off select services",
    cta: "Get my free inspection",
    bonus: "Free car inspection report included",
    campaignSeconds: 30,
    genericMessage:
        "Hi Revautoz, I found you through your website and would like to know more about your services.",
    exclusiveMessage:
        "Hi Revautoz, I want to claim the limited-time 25% exclusive discount + free vehicle inspection. I'd like to know the available slots.",
    claimMessage:
        "Hi Revautoz, I'd like to claim the offer — up to 20% off select services. Please share the details.",
    message:
        "Hi Revautoz, I'd like to book my free car inspection. I saw the offer — up to 20% off select services plus a free car inspection report.",
};

export const whatsappPrefill = (text) =>
    `https://wa.me/${site.whatsappNumber}?text=${encodeURIComponent(text)}`;

export const mapsDirectionsUrl = "https://maps.app.goo.gl/fikSuUn2XhfHgv5p7";

export const mapsEmbedUrl = "https://www.google.com/maps?q=15.6379849,73.8328668&z=17&output=embed";

export const assets = {
    emblem: "/assets/brand/rl-emblem.webp",
    emblemTransparent: "/assets/brand/rl-emblem-transparent.webp",
    lockup: "/assets/brand/rl-lockup.webp",
    campaignInterior: "/assets/brand/campaign-signature-interior.webp",
    facility: "/assets/brand/facility-storefront.webp",
    banner: "/assets/brand/ride-redefined-banner.webp",
};
